export default __webpack_public_path__ + "static/media/house-21.7d455cd9.jpg";